const MULTIPART = { 'Content-Type': 'multipart/form-data' };

export default function EnrolmentApi({ makeRequest, buildRequest }) {
	function getEnrolment(enrolmentId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Enrolment/${enrolmentId}`))
		);
	}

	function updateEnrolment(enrolmentId, payload) {
		return buildRequest().then((req) =>
			makeRequest(req.put(`/api/Enrolment/${enrolmentId}`, payload))
		);
	}

	function getEnrolmentSummaryByEnquiry(enquiryId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Enrolment/summary/enquiry/${enquiryId}`))
		);
	}

	function getEnrolmentSummaryByCentre(centreId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Enrolment/summary/centre/${centreId}`))
		);
	}

	function getActiveEnrolments(params) {
		return buildRequest().then((req) =>
			makeRequest(req.get('/api/Enrolment/active', { params }))
		);
	}

	function getEnrolmentSections(version) {
		const params = version != null ? { version } : undefined;
		return buildRequest().then((req) =>
			makeRequest(req.get('/api/Enrolment/sections', { params }))
		);
	}

	// Publishes edited sections as a new content version (latest + 1).
	function updateEnrolmentSections(payload) {
		return buildRequest().then((req) =>
			makeRequest(req.put('/api/Enrolment/sections', payload))
		);
	}

	function getEnrolmentPrefill(enquiryId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Enrolment/prefill/${enquiryId}`))
		);
	}

	function createInvitation(enrolmentId, contactIds) {
		return buildRequest().then((req) =>
			makeRequest(req.post('/api/Enrolment/invitation', { enrolmentId, contactIds }))
		);
	}

	function getInvitationStatus(enrolmentInvitationId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Enrolment/invitation/${enrolmentInvitationId}`))
		);
	}

	function completeEnrolment(enrolmentId) {
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Enrolment/${enrolmentId}/complete`))
		);
	}

	function finaliseEnrolment(enrolmentId) {
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Enrolment/${enrolmentId}/finalise`))
		);
	}

	function cancelEnrolment(enrolmentId, payload) {
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Enrolment/${enrolmentId}/cancel`, payload))
		);
	}

	function uploadEnrolmentFile(enrolmentId, file, onUploadProgress) {
		const form = new FormData();
		form.append('file', file, file.name);
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Enrolment/${enrolmentId}/files`, form, { headers: MULTIPART, onUploadProgress }))
		);
	}

	function initEnrolmentUpload(enrolmentId, payload) {
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Enrolment/${enrolmentId}/files/init`, payload))
		);
	}

	function uploadEnrolmentBlock(enrolmentId, uploadId, index, chunk) {
		const form = new FormData();
		form.append('chunk', chunk);
		return buildRequest().then((req) =>
			makeRequest(req.put(
				`/api/Enrolment/${enrolmentId}/files/${uploadId}/block/${index}`,
				form,
				{ headers: MULTIPART, timeout: 120000, suppressErrorToast: true },
			))
		);
	}

	function commitEnrolmentUpload(enrolmentId, uploadId, blockIndexes) {
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Enrolment/${enrolmentId}/files/${uploadId}/commit`, { blockIndexes }))
		);
	}

	function getEnrolmentFileContent(enrolmentId, enrolmentFileId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Enrolment/${enrolmentId}/files/${enrolmentFileId}`, { responseType: 'blob' }))
		);
	}

	function deleteEnrolmentFile(enrolmentId, enrolmentFileId) {
		return buildRequest().then((req) =>
			makeRequest(req.delete(`/api/Enrolment/${enrolmentId}/files/${enrolmentFileId}`))
		);
	}

	return {
		getEnrolment,
		updateEnrolment,
		getEnrolmentSummaryByEnquiry,
		getEnrolmentSummaryByCentre,
		getActiveEnrolments,
		getEnrolmentSections,
		updateEnrolmentSections,
		getEnrolmentPrefill,
		createInvitation,
		getInvitationStatus,
		completeEnrolment,
		finaliseEnrolment,
		cancelEnrolment,
		uploadEnrolmentFile,
		initEnrolmentUpload,
		uploadEnrolmentBlock,
		commitEnrolmentUpload,
		getEnrolmentFileContent,
		deleteEnrolmentFile,
	};
}
